import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

const sections = [
  {
    icon: "W",
    title: "Wallet & Promo",
    subtitle: "Gestisci credito clienti, ricariche, bonus e campagne wallet.",
    link: "/wallet?from=app-management",
    active: true,
  },
  {
    icon: "OFF",
    title: "Offerte App",
    subtitle: "Promozioni e offerte visibili dall'app cliente.",
    link: "/offers?from=app-management",
    active: true,
  },
  {
    icon: "IMG",
    title: "Media Prodotti & App",
    subtitle: "Immagini prodotto condivise tra gestionale e app cliente.",
    link: "/media-app",
    active: true,
  },
  {
    icon: "SP",
    title: "Sponsor & Partner",
    subtitle: "Sponsor cliccabili mostrati a carosello nell'app cliente.",
    link: "/gestione-app-clienti/sponsor",
    active: true,
  },
  {
    icon: "PT",
    title: "Fidelity / Punti e Premi",
    subtitle: "Punti, premi e logiche fidelity collegate all'app cliente.",
    link: "/clienti?from=app-management",
    active: true,
  },
  {
    icon: "PR",
    title: "Gestione Premi",
    subtitle: "Crea e modifica i premi fedeltÃ , i punti richiesti e i prodotti associati.",
    link: "/gestione-app-clienti/premi",
    active: true,
  },
  {
    icon: "ST",
    title: "Statistiche Fidelity",
    subtitle: "Analizza punti, premi, costi e andamento del programma fidelity.",
    link: "/gestione-app-clienti/statistiche-fidelity",
    active: true,
  },
  {
    icon: "QR",
    title: "Riscatta premio",
    subtitle: "Verifica il codice del cliente e conferma la consegna del premio.",
    link: "/gestione-app-clienti/riscatta-premio",
    active: true,
  },
  {
    icon: "ORD",
    title: "Storico Ordini App Clienti",
    subtitle: "Storico e gestione ordini arrivati dall'app cliente.",
    link: "/gestione-app-clienti/ordini",
    active: true,
  },
  {
    icon: "MSG",
    title: "Comunicazioni App",
      subtitle: "Mailing list clienti app, consensi marketing e invio promo.",
      link: "/gestione-app-clienti/comunicazioni",
      active: true,
  },
  {
    icon: "GIFT",
    title: "Buoni Regalo",
    subtitle: "Crea buoni esperienza, gift card wallet, verifica codici e convalida in negozio.",
    link: "/gestione-app-clienti/buoni-regalo",
    active: true,
  },
    {
      icon: "EV",
      title: "Cassa Eventi",
      subtitle: "Listini veloci per feste, sagre ed eventi con ricevute di cortesia e statistiche.",
      link: "/gestione-app-clienti/cassa-eventi",
      active: true,
    },
    {
      icon: "DEL",
      title: "Richieste eliminazione account",
      subtitle: "Visualizza e processa le richieste di chiusura account inviate dall'app.",
      link: "/gestione-app-clienti/eliminazione-account",
      active: true,
    },
    {
      icon: "HELP",
      title: "Centro Assistenza",
      subtitle: "Ticket assistenza, screenshot, risposte e stato lavorazione dei clienti.",
      link: "/gestione-app-clienti/assistenza",
      active: true,
    },
];

export default function AppManagementPage() {
  const nav = useNavigate();
  const [deleteRequestsPending, setDeleteRequestsPending] = useState(0);

  useEffect(() => {
    const loadDeleteRequests = async () => {
      try {
        const res = await authFetch(
          `${API_URL}/api/clienti/app-delete-requests/?status=PENDING`
        );

        const data = await res.json().catch(() => ({}));

        if (res.ok) {
          setDeleteRequestsPending(Number(data?.pending_count || 0));
        }
      } catch (e) {
        console.error("Errore richieste eliminazione account:", e);
      }
    };

    loadDeleteRequests();
  }, []);

  return (
    <div className="container py-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
        <div>
          <div className="text-muted small text-uppercase fw-semibold">
            Ecosistema App Cliente
          </div>
          <h1 className="fw-bold mb-1">Gestione App Clienti</h1>
          <div className="text-muted">
            Tutte le funzioni che comunicano con l'app cliente, raccolte in un'unica sezione.
          </div>
        </div>

        <button
          type="button"
          className="btn btn-outline-secondary rounded-pill px-4"
          onClick={() => nav("/")}
        >
          Torna alla Dashboard
        </button>
      </div>

      <style>{`
        .app-management-card-active {
          border-left: 6px solid #198754 !important;
          transition: transform .15s ease, box-shadow .15s ease;
        }
        .app-management-card-active:hover {
          transform: translateY(-3px);
          box-shadow: 0 .75rem 1.5rem rgba(0,0,0,.12) !important;
        }
      `}</style>

      

      <div className="row g-3">
        {sections.map((item) => (
          <div className="col-12 col-md-6 col-xl-4" key={item.title}>
            <div
              className={`card h-100 border-0 shadow rounded-4 ${item.active ? "app-management-card-active" : "opacity-75"}`}
              role={item.active ? "button" : undefined}
              onClick={() => {
                if (!item.active || !item.link) return;
                if (item.title === "Storico Ordini App Clienti") {
                  localStorage.setItem("dzr_return_to_app_management", "1");
                }
                nav(item.link);
              }}
              style={{ cursor: item.active ? "pointer" : "default" }}
            >
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-start gap-3">
                  <div>
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-3 fw-bold"
                      style={{
                        minWidth: 46,
                        height: 46,
                        padding: "0 10px",
                        borderRadius: 14,
                        background: "#f6eeee",
                        color: "#8b1e2d",
                        fontSize: 13,
                        letterSpacing: 0.4,
                      }}
                    >
                      {item.icon}
                    </div>
                    <h5 className="fw-bold mb-2">{item.title}</h5>
                    <div className="text-muted">{item.subtitle}</div>
                  </div>

                  {item.title === "Richieste eliminazione account" ? (
                    <span
                      className={`badge rounded-pill ${
                        deleteRequestsPending > 0
                          ? "text-bg-danger"
                          : "text-bg-success"
                      }`}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {deleteRequestsPending > 0
                        ? `${deleteRequestsPending} in attesa`
                        : "Nessuna richiesta"}
                    </span>
                  ) : (
                    <span
                      className={`badge rounded-pill ${item.active ? "text-bg-success" : "text-bg-light"}`}
                      style={{
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        minWidth: 58,
                        textAlign: "center",
                      }}
                    >
                      {item.active ? "Attivo" : "Prossimamente"}
                    </span>
                  )}
                </div>

                <div className="mt-4 small fw-semibold">
                  {item.active ? "Apri sezione >" : "Area placeholder"}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}



